if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const pro_con_ele = this.closest('.product__info-container')
      if( pro_con_ele ){
        const vari_input_eles = pro_con_ele.querySelectorAll('variant-radios fieldset.variant-item:not(.pf--colors)')
        vari_input_eles.forEach((fieldset)=>{
          if( fieldset.querySelector('input[type="radio"]:checked') == null ){
            fieldset.querySelector('.error_msg').classList.remove('hidden');
            let temoOut;
            clearTimeout(temoOut);
            temoOut = setTimeout(()=>{
              fieldset.querySelector('.error_msg').classList.add('hidden');
            }, 25000);
          }
        });
        
          pro_con_ele.querySelectorAll('variant-radios .variant-item.pf--colors').forEach((fieldset)=>{
            if( fieldset.querySelector('input[type="radio"]:checked') == null ){
              fieldset.querySelector('.error_msg').classList.remove('hidden');
              let temoOut;
              clearTimeout(temoOut);
              temoOut = setTimeout(()=>{
                fieldset.querySelector('.error_msg').classList.add('hidden');
              }, 25000);
            }
          });
        
        if(pro_con_ele.querySelector('[data-name="properties[_drainage_id]"]')){
          if(pro_con_ele.querySelectorAll('.product_variants .customs-options input:checked').length == 0){
            console.log(pro_con_ele.querySelectorAll('.product_variants .customs-options input:checked').length,'in2')
            pro_con_ele.querySelector('.product_variants .customs-options').parentElement.querySelector('.error_msg').classList.remove('hidden');
            let temoOut;
            clearTimeout(temoOut);
            temoOut = setTimeout(()=>{
              pro_con_ele.querySelector('.product_variants .customs-options').parentElement.querySelector('.error_msg').classList.add('hidden');
            }, 25000);
          }
        }
        if(pro_con_ele.querySelectorAll('variant-radios .variant-item:not(.pf--colors) input[type="radio"]:checked').length != vari_input_eles.length) return;
        if(pro_con_ele.querySelector('[data-name="properties[_drainage_id]"]')){
          if(pro_con_ele.querySelectorAll('.product_variants .customs-options input:checked').length == 0) return;
        }
      }      

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      const pro_info_con_ele = this.closest('.product__info-container'),
      extra_pro_obj = {}, qty = formData.get('quantity') || 1;
      extra_pro_obj.data = [];
      pro_info_con_ele.querySelectorAll('input[data-name][name]:not(.extraId)').forEach((input_ele)=>{        
        extra_pro_obj.data.push({
          id: Number(input_ele.value),
          quantity: Number(qty),
          properties: {
            _refeId: Number(input_ele.dataset.refId)
          }
        })
      });

      const items = [], items_object = {};
      if( extra_pro_obj.data.length ){
        var productData = { properties:{} }, product_arry = [];
        for (const pair of formData.entries()) {
          let key = pair[0];
          
          if( key.indexOf('properties') > -1 ){
            key = key.split('properties[')[1].replace(']','');
            if( key == '_drainage_id' || key == '_shelving_id' ){
              productData.properties[key] = Number(pair[1]);
            }else{
              productData.properties[key] = pair[1];
            }
          }else if( key == 'id' || key == 'quantity' ){            
            productData[pair[0]] = Number(pair[1]);
          }else if ( key == 'sections_url' || key == 'sections' || key == 'section-id'){
            items_object[pair[0]] = pair[1];
          }else{
            items_object[pair[0]] = pair[1];
          }
        }
        product_arry.push(productData);        
        extra_pro_obj.data = product_arry.concat(extra_pro_obj.data)        
        items_object['items'] = extra_pro_obj.data;
        //console.log(items_object)
      }
      callMainAddtoCart(this, formData, config, items_object);
      
      function callMainAddtoCart (ele_this, ele_formData, config, ele_items){        

        if( Object.entries(ele_items).length > 0 ){
          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';          
          delete config.headers['X-Requested-With'];
          config.body = JSON.stringify(ele_items);          
        }
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {            
            if (response.status || response.errors) {
              let err_des = response.errors ? response.errors : response.description,
              err_msg = response.errors ? response.errors : response.message;
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: ele_formData.get('id'), errors: err_des, message: err_msg});
              ele_this.handleErrorMessage(err_des);
              let has_added_msg = err_msg.indexOf('added to your cart') > -1 ? true : err_des.indexOf('added to your cart') ? true : false;
              if (ele_this.cart && response.status == 422 && has_added_msg ) {
                ele_this.updateCartDrawer(ele_this);
              }else if (ele_this.cart && has_added_msg ) {
                ele_this.updateCartDrawer(ele_this);
              }

              const soldOutMessage = ele_this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              ele_this.submitButton.setAttribute('aria-disabled', true);
              ele_this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              ele_this.error = true;
              return;
            } else if (!ele_this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!ele_this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: ele_formData.get('id')});
            ele_this.error = false;
            const quickAddModal = ele_this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { ele_this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              ele_this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            ele_this.submitButton.classList.remove('loading');
            if (ele_this.cart && ele_this.cart.classList.contains('is-empty')) ele_this.cart.classList.remove('is-empty');
            if (!ele_this.error) ele_this.submitButton.removeAttribute('aria-disabled');
            ele_this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
    }

    updateCartDrawer(ele_this) {
      var section = ele_this.cart.getSectionsToRender().map((section) => section.id)
      fetch(window.location.pathname + '?sections='+section)
        .then(res => res.json())
        .then(data => {
          setTimeout(() => {
            const quickAddModal = ele_this.closest('quick-add-modal');
            if (quickAddModal) {              
              quickAddModal.hide(true);
              if( quickAddModal.getAttribute('data-recommanaed-pro') != null ){
                document.querySelector('.shopify-section.product-section product-recommended').remove();
              }
            }
            ele_this.cart.renderContents(data, true); 
          }, 1250);            
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
